import { useHasRole } from '@/hooks/Auth/useRoles';
import { PAGES } from '@/shared/consts';
import { AdminNotFound } from '@/shared/pages/NotFound/AdminNotFound';

export const RoleRoute = ({ role, children }: { role: string; children: JSX.Element }) => {
  return useHasRole(role) ? children : <AdminNotFound $homePath={PAGES.SHARED.DEFAULT} />;
};
